import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

const BranchEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();

    const { isAuthenticated, companyId, userId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, userId, token, logout]);

    const [formData, setFormData] = useState({
        Name: '',
        BranchCode: '',
        ContactNumber1: '',
        Email: '',
        GSTNumber: '',
        CINNumber: '',
        AddressLine1: '',
    });



    useEffect(() => {
        fetchData('BranchApi', `/BranchDetails/${recordId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Branch Details:', error);
            });
    }, []);


    const handleChange = event => {
        const { name, value } = event.target;
        console.log(name, value); // Add this line to debug
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: 1,
        }));

        updateData('BranchApi', `${recordId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/branchIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;


    return (

        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Branch - Edit</h6>
                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                        onClick={handleSubmit}
                    >
                        <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> UPDATE
                    </Button>

                    <Button
                        component={Link}
                        to="/branchIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <ArrowCircleLeftIcon style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }} /> BACK TO LIST
                    </Button>
                </div>
                {/* Render fetched data */}
                <div className="w-full mb-2 flex">
                    <div className="w-4/5 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                            Branch Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Name' value={formData.Name} onChange={handleChange} type="text" placeholder="Enter Company name"
                            required
                            maxLength={50}
                        />
                    </div>

                    <div className="w-1/5 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                            Branch Code
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='BranchCode' value={formData.BranchCode} onChange={handleChange} type="text" placeholder="Enter Company Code" />
                    </div>

                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>


                <div className="w-full mb-2 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
                            Contact Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ContactNumber1' value={formData.ContactNumber1} onChange={handleChange} type="text" placeholder="Enter Contact Number 1"
                            required
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Email' value={formData.Email} onChange={handleChange} type="text" placeholder="Enter Email"
                            maxLength={40}
                            pattern={emailPattern.source}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            GST Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='GSTNumber' value={formData.GSTNumber} onChange={handleChange} type="text" maxLength={15} placeholder="Enter GST Number" />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            CIN Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='CINNumber' value={formData.CINNumber} onChange={handleChange} type="text" maxLength={30} placeholder="Enter CIN Number" />
                    </div>

                </div>

                <div className="w-full mb-2 flex">
                    <div className="w-full mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Address Line
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='AddressLine' value={formData.AddressLine} onChange={handleChange} type="text" placeholder="Enter Address Line 1"
                            maxLength={200}
                            required
                        />
                    </div>
                </div>

            </form>
        </div>

    );
};

export default BranchEdit;
